import { useNavigate } from 'react-router-dom'

// react-router v6 sets history.state.idx = 0 for the entry the SPA was first
// loaded on (direct/bookmarked visit). Any in-app push increments it, so
// idx > 0 means navigate(-1) has a same-app entry to return to; otherwise
// fall back to a fixed path instead of risking navigating out of the app.
const useSafeBack = (fallbackPath: string) => {
  const navigate = useNavigate()

  return () => {
    const idx = window.history.state?.idx

    if (typeof idx === 'number' && idx > 0) {
      navigate(-1)
    } else {
      navigate(fallbackPath)
    }
  }
}

export default useSafeBack
